import { render, staticRenderFns } from "./WillPensionNominateDetails.vue?vue&type=template&id=15e3ed9e"
import script from "./WillPensionNominateDetails.vue?vue&type=script&lang=js"
export * from "./WillPensionNominateDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports